import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ArtistDetail from './pages/ArtistDetail';
import ArtistsList from './pages/ArtistsList';
import EventDetail from './pages/EventDetail';
import StoreDetail from './pages/StoreDetail';
import StoreList from './pages/StoreList';
import NewsDetail from './pages/NewsDetail';
import NewsList from './pages/NewsList';
import EventsList from './pages/EventsList';
import VideoList from './pages/VideoList';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import UserAuth from './pages/UserAuth';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import FanAccount from './pages/FanAccount';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/artists" element={<ArtistsList />} />
        <Route path="/artists/:slug" element={<ArtistDetail />} />
        <Route path="/events" element={<EventsList />} />
        <Route path="/videos" element={<VideoList />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/store" element={<StoreList />} />
        <Route path="/store/:slug" element={<StoreDetail />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/success/:orderId" element={<CheckoutSuccess />} />
        <Route path="/login" element={<UserAuth mode="login" />} />
        <Route path="/register" element={<UserAuth mode="register" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/account" element={<FanAccount />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
